import { Row, Col } from "antd";
import { BadgeHelp, Phone, Smartphone, Mail } from "lucide-react";
import DataGroup from "../../DataGroup";
import DataItem from "../../DataItem";

export default function PASection(props) {
  const { verification, setVerification, hidden, loading } = props;

  const responsiveInfo = {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 12,
    xl: 12,
    xxl: 8,
  };

  return (
    <Col {...responsiveInfo}>
      <DataGroup
        title={
          !verification?.NombreCompletoPA
            ? "Persona que atiende la visita"
            : `ATIENDE: ${verification?.NombreCompletoPA} ${verification?.CargoPA ? "(" + verification?.CargoPA + ")" : ""}`
        }
        subtitle={
          verification?.TipoPersonaPA_T && verification?.NacionalidadPA_T
            ? "Persona " + verification?.TipoPersonaPA_T + ", " + verification?.NacionalidadPA_T
            : null
        }
        formName={"Persona que atiende la visita"}
        mainData={verification}
        setMainData={setVerification}
        verification={verification}
      >
        <DataItem
          icon={<BadgeHelp size={16} />}
          iconColor="brown"
          keyName={verification?.TipoDatoPA_T ? verification?.TipoDatoPA_T : "Tipo de identificación"}
          value={verification?.DatoPA_T}
          valueType="string"
          fieldWidth={8}
          hidden={hidden}
          loading={loading}
        />
        <DataItem
          icon={<Phone size={16} />}
          iconColor="#1890ff"
          keyName="Teléfono fijo"
          value={verification?.TelefonoFijoPA_T}
          valueType="phone"
          fieldWidth={8}
          hidden={hidden}
          loading={loading}
        />
        <DataItem
          icon={<Smartphone size={16} />}
          iconColor="indigo"
          keyName="Teléfono móvil"
          value={verification?.TelefonoMovilPA_T}
          valueType="phone"
          fieldWidth={8}
          hidden={hidden}
          loading={loading}
        />
        <DataItem
          icon={<Mail size={16} />}
          iconColor="#1890ff"
          keyName="Correo electrónico"
          value={verification?.CorreoElectronicoPA_T}
          valueType="email"
          fieldWidth={8}
          hidden={hidden}
          loading={loading}
        />
      </DataGroup>
    </Col>
  );
}